import { type InmatePostalMailFilters } from '@reliance/types/filters/InmatePostalMailFilters';
import { type InmatePostalMailWithDownloadUrl } from '@reliance/types/models/InmatePostalMail';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiService } from '../types/ApiService';

export const inmatePostalMail = (centralApi: ApiService) => ({
  index: (
    params: InmatePostalMailFilters = {},
  ): Promise<PaginatedResponse<InmatePostalMailWithDownloadUrl>> => {
    return centralApi.get('/inmate-postal-mail', { params });
  },

  get: (id: number): Promise<InmatePostalMailWithDownloadUrl> => {
    return centralApi.get(`/inmate-postal-mail/${id}`);
  },

  approve: (id: number) => {
    return centralApi.put(`/inmate-postal-mail/${id}/approve`);
  },

  reject: (id: number, rejectionReason: string) => {
    return centralApi.put(`/inmate-postal-mail/${id}/reject`, {
      note: rejectionReason,
    });
  },
});
